function initIntercom(userData) {
  global.Intercom('shutdown');
  global.Intercom('update', {
    app_id: 'd1z9zvu6',
    name: userData.firstname,
    email: userData.email,
  });
}
export { initIntercom };
